interface NotificationConfig {
  show: boolean;
  bodyTextKey: string;
}

export function getNotificationConfig(url: string, context: string): NotificationConfig {
  if (url.endsWith('/transactionCompleted')) {
    return {
      show: true,
      bodyTextKey: `TRANSACTION.COMPLETED.${context.toUpperCase()}`
    };

  } else if (url.endsWith('/transactionIncompleted')) {
    return {
      show: true,
      bodyTextKey: `TRANSACTION.INCOMPLETED.${context.toUpperCase()}`
    };

  } else if (url.endsWith('transactionIncompleted?info=canceled')) {
    return {
      show: true,
      bodyTextKey: `TRANSACTION.INCOMPLETED.CANCELLED`
    };

  } else if (url.endsWith('/transactionExpired')) {
    return {
      show: true,
      bodyTextKey: `TRANSACTION.EXPIRED`
    };
  }
  return { show: false, bodyTextKey: '' };
}
